<template>
  <div>
    <commissions :plan-media="dcf" detail></commissions>
    <liste-commissions :dcf="dcf"></liste-commissions>
  </div>
</template>

<script>
import commissions from '@/components/planMedia/edition/commissions';
import listeCommissions from '@/components/commissions/listeCommissions';

export default {
  name: 'commissionsCommande',
  components: {
    listeCommissions,
    commissions,
  },
  props: {
    dcf: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
